/**
 * Modals Plugin
 * Author Name: Consultwebs
 * Description: This is a plugin to use in our current framework
 */
import 'wicg-inert';
/**
 * IE6 Class to Create Modals
 */
class CwModals {
  constructor(DOMclassName, settings = {}) {
    this.bodyElements = document.querySelectorAll('body > *:not(.cw__modal-dialog)');
    this.modalClass = DOMclassName;
    this.settings = settings;
    this.modalTarget = '';
    this.modal = '';
    this.closeButton = '';
  }

  /**
   * Function to initialize Modals
   */
  init() {
    if (!this.modalClass) throw new Error('No DOM class element specified!');
    window.addEventListener('click', (event) => {
      if (event.target.matches(this.modalClass)) {
        event.preventDefault();
        this.startModals(event.target);
        this.cwWindowEvs();
      }
    });
  }

  startModals(button) {
    this.modalTarget = button.dataset.cwTarget;
    this.modal = document.querySelector(this.modalTarget);
    this.previousActiveElement = document.activeElement;
    this.closeButton = this.modal.querySelector('.close');

    if (!this.modal) throw new Error(`Target modal is missing!`);
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.setInertProps(true);
    this.openModal();
    this.modal.addEventListener('click', (e) => {
      const isOutside = !e.target.closest('.inner-modal');
      if (isOutside) this.closeModal();
    });
  }

  /**
   * Using Inert library to deactivate DOM elements in the DOM when a Popup
   * Is showed up. This is useful for accessibility
   */
  setInertProps(setTo) {
    this.bodyElements.forEach((child) => {
      child.inert = setTo;
    });
  }

  cwWindowEvs() {
    // Handle ESC key
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (this.modal.matches('.open')) {
          this.closeModal();
        }
      }
    });
  }

  openModal() {
    this.modal.classList.add('open');
    // Checking if this is a video modal
    const iFrame = document.querySelector('.inner-modal .modal-content .modal-body iframe');
    if (iFrame) {
      const src = iFrame.getAttribute('src') + "&mute=1";
      iFrame.setAttribute('src',src);
    } 
    this.modal.focus();
  }

  closeModal() {
    if (this.modal.matches('.open')) {
      this.setInertProps(false);

      setTimeout(() => {
        this.modal.classList.remove('open');
        
        // Checking if this is a video modal
        const iFrame = document.querySelector(".inner-modal .modal-content .modal-body iframe");
        if (iFrame) {
          let src = iFrame.getAttribute("src");
          if (src.search("mute=1") > 0) {
            src = src.replace("&mute=1", "");
            iFrame.setAttribute("src", src);
          }
        }
        this.previousActiveElement.focus();
      }, 100);
    }
  }
}

// window.cwModals = cwModals;

export default CwModals;
